import React, { useEffect, useState } from "react";
import "./AwardDirectory.scss";
import { Description } from "../../../../Global/GlobalText";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../../Global/GlobalButton";
import { useNavigate } from "react-router-dom";
import { InputLabel } from "../../../../Global/GlobalFormElement";
import { Switch } from "@mui/joy";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../../Url/Url";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLoading } from "../../../../LoadingContext";

export const AwardDirectory = ({ setSelectedButton, publicId,updatePublicId }) => {
  const [checked, setChecked] = useState(false);
  const eventId = useSelector((state) => state?.users?.id || "");

    const { setLoading } = useLoading(); 
  
   
  useEffect(() => {
    setChecked(publicId === 1); // Sync checked state when publicId updates
  }, [publicId]); 


  const navigate = useNavigate();

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true); //Loader
    try {
      const response = await axios.post(
        `${EXCHNAGE_URL}/awardDirectory`,
        {
          eventId,
          is_publicly_visble: checked ? 1 : 0,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 200) {
          toast.success("Category updated successfully!");
          setSelectedButton(1);
          updatePublicId(checked ? 1 : 0); // ✅ Update eventData.publicId in the parent
        } else {
        console.error("Error Message:", response.data.message);
        toast.error(response.data.message || "Failed to update category.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while updating the category.");
    }finally {
      setLoading(false); //Loader
    }
  };

  return (
    <div>
      <form className="newevent_form" onSubmit={handleSave}>
        <div className="submissionid_format">
          <Description>
            Award Directory displays all the awards hosted on Judgify which are
            visible to public. Click here to view Award Directory page.
          </Description>
        </div>

        <div className="awarddirectory_visible">
          <div className="awarddirectory_visible_btn">
            <InputLabel>Visible To Public</InputLabel>
            <span>
              {/* <Switch
                checked={checked}
                onChange={(event) => setChecked(event.target.checked)}
              /> */}
              <Switch
                checked={checked}
                onChange={(event) => setChecked(event.target.checked)}
                color={checked ? "success" : "neutral"}
                variant={checked ? "solid" : "outlined"}
                endDecorator={checked ? "On" : "Off"}
                slotProps={{
                  endDecorator: {
                    sx: {
                      minWidth: 24,
                    },
                  },
                }}
              />
              {/* {/ <Description>No</Description> /} */}
            </span>
          </div>

          <Description style={{ fontStyle: "italic" }}>
            Setting 'Public' as 'Yes' means your event will be displayed on
            'Award Directory' page
          </Description>
        </div>

        <div className="newevent_btndiv">
          <GreyBorderButton
            onClick={() => {
              navigate(setSelectedButton(4));
            }}
          >
            Cancel
          </GreyBorderButton>

          <RedBackgroundButton
            // onClick={() => {
            //   navigate(setSelectedButton(1));
            // }}
            type="submit"
          >
            Save
          </RedBackgroundButton>
        </div>
      </form>
    </div>
  );
};
